import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import {
  DataGrid,
  Column,
  Selection,
  HeaderFilter
} from 'devextreme-react/data-grid';
import {
  routines as decisionsActions,
  isNegotiationListLoadingSelector,
  negotiationListSelector
} from '../../reducers/db/decisions';
import './style.css';

class ViewNegotiation extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };

  componentDidMount() {
    const { data } = this.props;

    this.props.getNegotiationList(data.questionId);
  }

  handleClick = dealId => {
    // set dealId in local storage
    window.localStorage.setItem('dealId', dealId);
    const { sectionList } = this.props;
    if (sectionList[0].length > 0) {
      window.localStorage.setItem('section', sectionList[0][0].entityName);
    }
    setTimeout(() => {
      window.location.href = '/dashboard';
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }, 0);
  };
  render() {
    const { className, negotiationList, data } = this.props;
    const classList = classNames('change-client-view', className);

    return (
      <div className={classList}>
        <div className="change-client-view-title">
          <i className="fas fa-building change-client-view-title-icon" />
          <span className="change-client-view-title-label">
            Negotiation History For {data.questionName}
          </span>
          <div>
            <br />
            <DataGrid
              dataSource={negotiationList.negotiationList}
              id="gridDealsContainer"
              noDataText="No Negotiation history found"
              onSelectionChanged={this.onSelectionChanged}
              ref={ref => (this.dataGrid = ref)}
              showColumnLines={false}
              showRowLines={false}
              showBorders={false}
              rowAlternationEnabled={true}
              allowColumnReordering
              columnAutoWidth={false}
              allowColumnResizing
              height="300">
              <Selection mode="single" />
              <HeaderFilter visible={false} />
              <Column dataField="lastModifiedBy" caption="ADDED BY" />
              <Column
                dataField="lastModifiedDateTime"
                caption="NEGOTIATION DATE"
                dataType="date"
                format="MM/dd/yyyy"
              />
              <Column dataField="notes" caption="NOTES" />
            </DataGrid>
          </div>
        </div>
      </div>
    );
  }
}

const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    return {
      isNegotiationListLoading: isNegotiationListLoadingSelector(state, props),
      negotiationList: negotiationListSelector(state, props)
    };
  };
  return mapStateToProps;
};

const mapDispatchToProps = {
  getNegotiationList: decisionsActions.getNegotiationList
};

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(ViewNegotiation);
